import React, { Dispatch, memo, SetStateAction } from 'react';

import styles from './FlatTreeInput.module.scss';

interface IFlatTreeInputProps {
	testName?: string;
	validateInput?: (value: string) => boolean;
	inputValue?: string;
	setInputValue: Dispatch<SetStateAction<string | undefined>>;
}

const FlatTreeInput = ({
	testName,
	validateInput,
	setInputValue,
	inputValue,
}: IFlatTreeInputProps) => {
	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		e.stopPropagation();

		const inputValue = e.target.value;

		if (validateInput && validateInput(inputValue)) {
			setInputValue(inputValue);
		} else if (!validateInput) {
			setInputValue(inputValue);
		}
	};

	return (
		<input
			className={styles.treeInput}
			data-testid={`tree_input_${testName}`}
			onChange={onChange}
			type='text'
			value={inputValue}
		/>
	);
};

export default memo(FlatTreeInput);
